import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#6d4aff", contrastText: "#ffffff" },
    secondary: { main: "#f5c518", contrastText: "#1a1400" },
    error: { main: "#ff4d4f" },
    success: { main: "#6d4aff" },
    background: {
      default: "#0b0f14",
      paper: "#151b24",
    },
    text: {
      primary: "#f4f7fb",
      secondary: "#8b9bb0",
    },
  },
  typography: {
    fontFamily: "proxima-nova, ui-sans-serif, -apple-system, system-ui, sans-serif",
    button: { textTransform: "none", fontWeight: 700 },
    h3: { fontWeight: 800 },
    h4: { fontWeight: 800 },
    h6: { fontWeight: 700 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: "proxima-nova, ui-sans-serif, -apple-system, system-ui, sans-serif",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 10, boxShadow: "none", fontWeight: 700 },
        containedPrimary: {
          "&:hover": { boxShadow: "0 0 0 1px rgba(109,74,255,0.28), 0 8px 24px rgba(109,74,255,0.22)" },
        },
        outlinedSecondary: {
          "&:hover": {
            borderColor: "rgba(109, 74, 255, 0.5)",
            backgroundColor: "rgba(109, 74, 255, 0.1)",
          },
        },
        containedSecondary: {
          "&:hover": {
            backgroundColor: "#ffd84d",
            boxShadow: "0 8px 22px rgba(245, 197, 24, 0.24)",
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: { variant: "outlined" },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          letterSpacing: "0",
          wordSpacing: "normal",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: "#0e141c",
          borderRadius: 12,
          "& fieldset": { borderColor: "rgba(255,255,255,0.08)" },
          "&:hover fieldset": { borderColor: "rgba(255,255,255,0.16)" },
          "&.Mui-focused fieldset": { borderColor: "#6d4aff" },
        },
        input: {
          letterSpacing: 0,
          wordSpacing: "normal",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 600,
          background: "#1c2530",
          color: "#c5d0dc",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
  },
});

export default theme;
